import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";

function SelectInput({
  options = [],
  value,
  name,
  id = "",
  handleChange,
  isMulti = false,
  defaultValue,
  isDisabled = false,
  closeMenuOnSelect = true,
  isLoading = false,
  isClearable = true,
  placeholder = "-- Select --",
  label,
  required,
  classNamePrefix,
  errorMessage = {},
  cName,
  handleBlur,
}) {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const selectRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleScroll = (event) => {
      if (window.innerWidth <= 768) return;
      if (!menuIsOpen) return;

      // Find the dropdown menu dynamically
      const menuElement = document.querySelector(".react-select__menu");
      if (menuElement) {
        menuRef.current = menuElement; // Set reference dynamically
      }

      if (menuRef.current && menuRef.current.contains(event.target)) {
        return; // Do nothing if scrolling inside the dropdown
      }

      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setMenuIsOpen(false); // Close menu if scrolling outside
      }
    };

    const scrollContainers = document.querySelectorAll("div, section, main"); // Track all scrollable elements
    scrollContainers.forEach((el) =>
      el.addEventListener("scroll", handleScroll, true),
    );

    return () => {
      scrollContainers.forEach((el) =>
        el.removeEventListener("scroll", handleScroll, true),
      );
    };
  }, [menuIsOpen]);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      // paddingTop: "2px",
      margin: "3px 0px",
      minHeight: "40px",
      borderColor:
        errorMessage && errorMessage[name] ? "red" : base.borderColor,
      "&:hover": {
        borderColor:
          errorMessage && errorMessage[name] ? "red" : base.borderColor,
      },
      boxShadow: state.isFocused
        ? errorMessage && errorMessage[name]
          ? "0 0 5px 1px red"
          : base.boxShadow
        : null,
      fontSize: "15px",
      fontWeight: 400,
      backgroundColor: isDisabled ? "#e9ecef" : "#ffffff",
    }),
    menu: (provided) => ({
      ...provided,
      fontSize: "15px",
      overflow: "auto",
      fontWeight: 400,
      zIndex: 1050,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999, // Ensures the dropdown stays above modal
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
  };

  return (
    <div ref={selectRef}>
      {label && (
        <label className="form-label col-form-label w-100 font-size-14 form-label-custom-visible p-0">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}

      <Select
        className={`font-size-14 ${cName}`}
        name={name}
        id={id}
        styles={customStyles}
        options={options}
        value={
          isMulti
            ? options?.filter((opt) =>
                value?.some((val) => val.value === opt.value),
              ) // For multi-select
            : options?.find((opt) => opt.value === value) || null // For single select
        }
        onChange={handleChange}
        onBlur={handleBlur}
        isMulti={isMulti}
        defaultValue={defaultValue}
        closeMenuOnSelect={closeMenuOnSelect}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isClearable={isClearable}
        placeholder={placeholder}
        classNamePrefix={classNamePrefix}
        menuPortalTarget={document.body} // Ensures dropdown is appended to body
        menuPosition="fixed" // Keeps dropdown in fixed position
        menuIsOpen={menuIsOpen} // Controls dropdown state
        onMenuOpen={() => setMenuIsOpen(true)}
        onMenuClose={() => setMenuIsOpen(false)}
      />

      {/* Display error message */}
      {errorMessage &&
        errorMessage[name] &&
        Object?.keys(errorMessage).length > 0 && (
          <div className="text-danger fw-700 fs-6">
            {errorMessage && errorMessage[name] && errorMessage[name]}
          </div>
        )}
    </div>
  );
}

export default SelectInput;
